
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

/**
 * Provider for the application routes configuration.
 *
 * @export
 * @param {AngularModule} app
 */
export default function (app) {
	app.factory('utilitiesFactory', utilitiesFactory);

	/**
	 * Services to stock common variables, function to uses in all application.
	 *
	 * @param {any} $state
	 * @param {any} SweetAlert
	 * @param {any} restClientServices
	 * @param {any} utilitiesConstant
	 * @returns
	 */
	function utilitiesFactory($state, $window, SweetAlert, restClientServices, utilitiesConstant) {
		'ngInject';

		return {
			downloadUserManual: downloadUserManual,
			lockBackSpace: lockBackSpace,
			logout: logout,
			orderComponents: orderComponents,
			redirectHomeByProfile: redirectHomeByProfile,
			showMessage: showMessage,
			showAlertMessage: showAlertMessage,
			showErrorMessage: showErrorMessage,
			showInfoMessage: showInfoMessage,
			showSuccessMessage: showSuccessMessage,
			showPromptMessage: showPromptMessage
		};

		/**
	 * Function that invokes the REST service to download user manual of the application.
	 *
	 * @param {any} urlMethod
	 * @returns
	 */
		function downloadUserManual() {
			return restClientServices.downloadService(utilitiesConstant.URL_ENDPOINT.concat(utilitiesConstant.URL_API_METHOD.DOWNLOAD_USER_MANUAL));
		}

		/**
		 * Function used to disable the backspace key in the browser to not navigate to the previous page.
		 *
		 */
		function lockBackSpace() {
			angular.element($window).bind('keydown', evt => {
				evt = evt || window.event;
				const nodeName = evt.target.nodeName.toLowerCase();

				const key = evt.which || evt.keyCode;
				/**
				 * 8 is the key assigned to the backSpace key on the browser.
				 */
				if (key === 8) {
					if ((nodeName === 'input' || nodeName === 'textarea') && evt.target.type !== 'checkbox') {
						return true;
					} else {
						evt.preventDefault();
						return false;
					}
				}
			});
		}

		/**
		 * Function that invokes the REST service to logout of the application.
		 *
		 * @param {any} urlMethod
		 * @returns
		 */
		function logout(urlMethod) {
			return restClientServices.postService(urlMethod, null, null, {});
		}

		/**
		 * Function that sort the components list in ascending order by campaign, emission and code attributes.
		 *
		 * @param {any} components
		 * @returns
		 */
		function orderComponents(components) {
			const attributes = ['campaign', 'emission', 'boxCode', 'bundleCode', 'stripCode', 'stripCode'];
			const orderAttributes = ['asc'];
			return _.orderBy(components, attributes, orderAttributes);
		}

		/**
		 * Redirect to home page associate with de user profile.
		 *
		 * @param {any} profile
		 */
		function redirectHomeByProfile(profile) {
			if (profile === utilitiesConstant.PROFILE.ADMIN) {
				$state.go('campaign');
			} else if (profile === utilitiesConstant.PROFILE.CASHIER) {
				$state.go('confirmed');
			} else if (profile === utilitiesConstant.PROFILE.COMPANY) {
				$state.go('confirmed');
			} else {
				$state.go('notFound');
			}
		}

		/**
		 * Show messages with warning styles.
		 *
		 * @param {any} message
		 */
		function showAlertMessage(message) {
			showMessage(message, 'warning');
		}

		/**
		 * Show messages with error styles.
		 *
		 * @param {any} message
		 */
		function showErrorMessage(message) {
			showMessage(message, 'error');
		}

		/**
		 * Show messages with information styles.
		 *
		 * @param {any} message
		 */
		function showInfoMessage(message) {
			showMessage(message, 'info');
		}

		/**
		 * Show messages with success styles.
		 *
		 * @param {any} message
		 */
		function showSuccessMessage(message) {
			showMessage(message, 'success');
		}


		/**
		 * Show a message, invoking a function depending on the user response
		 * @param {*} title
		 * @param {*} message
		 * @param {*} linkFunction
		 */
		function showPromptMessage(title, message, fn) {
			SweetAlert.swal({
				title: title,
				text: message,
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#009688',
				cancelButtonColor: '#009688',
				confirmButtonText: 'Continuar',
				cancelButtonText: 'Cancelar',
				confirmButtonClass: 'md-raised md-primary',
				cancelButtonClass: 'md-raised md-primary',
				buttonsStyling: false
			}, result => {
				if(result) {
					fn();
				}
			});
		}

		/**
		 * Show alert (SweetAlert) with message sent how parameter.
		 *
		 * @param {any} message
		 * @param {any} messageType
		 */
		function showMessage(message, messageType) {
			SweetAlert.swal({
				confirmButtonColor: '#009688',
				confirmButtonText: 'Continuar',
				confirmButtonClass: 'md-raised md-primary',
				buttonsStyling: false,
				text: message,
				title: '',
				type: messageType
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/core/services/utilities.factory.js